import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToolbarSeparator } from 'material-ui';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';

import DateRange from './dashboardFilter/dateRange';
import DashboardFilter from './dashboardFilter/button';
import DashboardWidget from './dashboardWidget';

import {
  initDashboard as initDashboardAction,
  loadDashboard as loadDashboardAction,
  resetGlobalFilters as resetGlobalFiltersAction,
  updateGlobalListFilter as updateGlobalListFilterAction,
  clearListFilter as clearListFilterAction,
  loadContractFolders as loadContractFoldersAction,
  updateFilter as updateFilterAction,
  updateWidgetFilter as updateWidgetFilterAction,
} from '../__storeFiles__/actions';

const { array, func, object, string, bool } = PropTypes;

const styles = {
  container: {
    maxWidth: '1440px',
    margin: '0px auto',
    padding: '0px',
    marginTop: '8px',
  },
  navigation: {
    backgroundColor: 'rgba(0, 0, 0, 0.54',
  },
  accentColors: {
    total: {
      color: 'rgb(165, 165, 165)',
    },
    received: {
      color: 'rgb(239, 239, 123)',
    },
    accepted: {
      color: 'rgb(0, 86, 98)',
    },
    loaded: {
      color: 'rgb(63, 166, 65)',
    },
    bounced: {
      color: 'rgb(211, 74, 73)',
    },
  },
};

class ContractorDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFilterOpen: false,
      isDatePickerOpen: false,
    };
  }

  componentDidMount = () => {
    const { loadContractFolders, initialized, loadDashboard } = this.props;
    if (!initialized) {
      this.initDashboard();
    } else {
      loadDashboard();
    }
    loadContractFolders();
  }

  resetGlobalFilters = () => {
    const { resetGlobalFilters } = this.props;
    this.toggleGlobalFilterDrawer();
    resetGlobalFilters();
  }

  onSubmitClick = () => {
    this.toggleGlobalFilterDrawer();
    this.props.loadDashboard();
  }

  toggleGlobalFilterDrawer = () => {
    this.setState({ isFilterOpen: !this.state.isFilterOpen });
  }

  initDashboard = () => {
    this.props.initDashboard(this.props.companyType);
  }

  updateGlobalFilter = (filterItem, value) => this.props.updateFilter(filterItem, value);

  render() {
    const {
      classes,
      globalFilters,
      widgets,
      updateGlobalListFilter,
      clearListFilter,
    } = this.props;
    return (
      <div className={classes.container}>
        <div style={{ display: 'flex', marginBottom: '8px' }}>
          <DashboardFilter
            filterLabel="Contract Filters"
            filters={globalFilters}
            isFilterOpen={this.state.isFilterOpen}
            onButtonClick={this.toggleGlobalFilterDrawer}
            onResetClick={this.resetGlobalFilters}
            onSubmitClick={this.onSubmitClick}
            updateGlobalFilter={this.updateGlobalFilter}
            clearListFilter={clearListFilter}
            updateGlobalListFilter={updateGlobalListFilter}
          />
        { /* <ToolbarSeparator style={{ margin: '0 16px' }} />
          <DateRange
            dateChoices={globalFilters.dateRange.dateChoices}
            isDatePickerOpen={this.state.isDatePickerOpen}
            onButtonClick={this.handleDatePickerClick}
            onSubmitClick={this.props.loadDashboard}
            updateGlobalFilter={this.updateGlobalFilter}
          /> */}
        </div>
        { /* <div style={{ flexWrap: 'nowrap', display: 'flex', justifyContent: 'space-evenly', marginBottom: '12px' }}>
          {
            widgets
              .filter(item => item.y === 0)
              .sort((a, b) => a.x - b.x)
              .map((widget, i) => <CallOut
                containerStyle={
                  Object.assign({}, widget.name.split(' ')[0].toLowerCase() === 'bounced' ? { backgroundColor: '#d34a4a' } : {})}
                key={i}
                title={widget.name}
                value={widget.data}
                isFirstChild={i === 0}
                isLoading={widget.isLoading}
                textStyle={Object.assign({}, widget.name.split(' ')[0].toLowerCase() === 'bounced' ? { color: '#ffffff' } : {})}
                titleStyle={Object.assign({ fontSize: '12px', padding: '0' }, widget.name.split(' ')[0].toLowerCase() === 'bounced' ? { color: 'rgb(255,255,255)' } : {})}
                accentColor={styles.accentColors[widget.name.split(' ')[0].toLowerCase()].color}
              />)
          }
        </div> */}
        <div style={{ display: 'flex', flex: 1, justifyContent: 'space-evenly', marginBottom: '12px' }}>
          <div style={{ flexDirection: 'column', flexWrap: 'wrap', display: 'flex', marginRight: '44px' }}>
            { widgets
                .filter(item => item.y === 1)
                .sort((a, b) => a.x - b.x)
                .map((widget, i) =>
                  <DashboardWidget
                    containerStyle={{ marginTop: i === 0 ? 0 : '12px' }}
                    data={widget.data}
                    filters={widget.filters}
                    grid={widget.size}
                    isLoading={widget.isLoading}
                    key={i}
                    title={widget.name}
                    type={widget.chart}
                    updateFilter={this.props.updateWidgetFilter}
                    widgetId={widget.id}
                  />
                )
            }
          </div>
          <div style={{ flexWrap: 'wrap', display: 'flex' }}>
            { widgets
                .filter(item => item.y === 2)
                .sort((a, b) => a.x - b.x)
                .map((widget, i) =>
                  <DashboardWidget
                    containerStyle={{ marginTop: i === 0 ? 0 : '12px' }}
                    data={widget.data}
                    filters={widget.filters}
                    grid={widget.size}
                    isLoading={widget.isLoading}
                    key={i}
                    title={widget.name}
                    type={widget.chart}
                    updateFilter={this.props.updateWidgetFilter}
                    widgetId={widget.id}
                  />
                )
            }
            {/*<DashboardWidget grid={[2, 2]} title="TourConnect Network" containerStyle={{ marginTop: '12px' }}>
              <p>Fill It Up</p>
            </DashboardWidget>*/}
          </div>
        </div>
      </div>
    );
  }
}

ContractorDashboard.propTypes = {
  classes: object,
  dispatch: func,
  globalFilters: object,
  loadContractFolders: func,
  loadDashboard: func,
  resetGlobalFilters: func,
  updateFilter: func,
  updateWidgetFilter: func,
  widgets: array,
  companyType: string,
  clearListFilter: func,
  updateGlobalListFilter: func,
  initialized: bool,
};

const mapDispatchToProps = ({
  loadDashboard: loadDashboardAction,
  loadContractFolders: loadContractFoldersAction,
  resetGlobalFilters: resetGlobalFiltersAction,
  updateFilter: updateFilterAction,
  updateWidgetFilter: updateWidgetFilterAction,
  initDashboard: initDashboardAction,
  updateGlobalListFilter: updateGlobalListFilterAction,
  clearListFilter: clearListFilterAction,
});

const mapStateToProps = ({ contractingDashboard, user }) => (
  {
    companyType: user.getIn(['company', 'companyType']),
    initialized: contractingDashboard.initialized,
    globalFilters: contractingDashboard.globalFilters,
    widgets: contractingDashboard.items,
  });

export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(ContractorDashboard));



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/container.jsx